// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-05-04
import React from 'react';
import css from './TextInCircle.module.scss';
import classNames from 'classnames';
import { THEME, ThemeName } from 'src/constants/ThemeNames';

/** Props for TextInCircle. theme accepts ThemeName values; string is a temporary widening pending AddSkipServices refactor. */
interface IProps {
    text: string;
    // TO-DO remove string when AddSkipServices is refactored to use ThemeName type for theme prop
    theme: ThemeName| string;
}

const FONT_WEIGHT_BASE_THEMES = new Set<ThemeName | string>([
    THEME.BMW, THEME.FORD, THEME.INFINITI, THEME.HONDA, THEME.BUICK,
    THEME.MERCEDES_BENZ, THEME.MAZDA, THEME.ACURA, THEME.GENESIS, THEME.LEXUS,
]);

/** Renders text inside a circular badge. Diameter scales with text length;
 * CSS modifier class is selected based on the OEM theme. */
const TextInCircle = (props: IProps) => {
    const { text, theme } = props;
    const diameter = text.length + 3;

    const circleStyle = {
        width: `${diameter}rem`,
        height: `${diameter}rem`,
        lineHeight: `${diameter}rem`,
    };

    const styleClasses = classNames(
        css.OrLiteral,
        {
            [css.OrLiteralSPM]: theme === THEME.TOYOTA_SPM,
            [css.OrLiteralLM]: theme === THEME.LEXUS_MONOGRAM,
            [css.OrLiteralCV]: theme === THEME.CHEVROLET,
            [css.fontWeightBaseText]: FONT_WEIGHT_BASE_THEMES.has(theme),
        },
    );

    return (
        <div className={css.OrLiteralWrapper} >
            <div className={styleClasses} style={circleStyle} data-testid='text-in-circle'>
                {text}
            </div>
        </div>
    );
};

export default TextInCircle;
